import React from 'react';
import Styles from './index.less';
import { PlayerTransitionHandler } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/slide-transition/player-transition-handler';
import {
    ImplementationType,
    TransitionTarget,
} from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import '@player/src/components/transition-wrapper/index.less';
import { IAnimationUpdateParams } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/slide-transition/interface';
import {
    ITransitionPreviewProps,
    ITransitionPreviewState,
} from '@src/slide/application/service/transition-service/preview/interface';

const DefaultTransitionStyle = {
    opacity: 1,
    zIndex: 0,
};

export class TransitionPreview extends React.Component<ITransitionPreviewProps, ITransitionPreviewState> {
    private enterRef: any;
    private exitRef: any;
    private transitionHandler: PlayerTransitionHandler;
    private timer: ReturnType<typeof setTimeout> | null;
    private enterCanvas: HTMLDivElement;
    private exitCanvas?: HTMLDivElement;
    private blackPlaceHolder: HTMLDivElement | null;

    constructor(props) {
        super(props);

        this.state = {
            exitStyle: DefaultTransitionStyle,
            enterStyle: DefaultTransitionStyle,
        };

        this.enterCanvas = props.enterCanvas;
        this.exitCanvas = props.exitCanvas;

        this.transitionHandler = new PlayerTransitionHandler({
            slideModel: this.props.enterSlideModel,
            getPrevSlideModel: () => this.props.exitSlideModel,
            isSwitchForward: () => false,
            beforeAnimation: this.handleBeforeAnimation,
            renderAnimationFrame: (params, renderInner) => {
                if (!renderInner) {
                    this.updateElementState(params);
                }
            },
            afterAnimation: this.handleAfterAnimation,
            enterCanvas: this.props.enterBrowserCanvas,
            exitCanvas: this.props.exitBrowserCanvas,
            getEnterWrapper: () => this.enterRef,
            getExitWrapper: () => this.exitRef,
        });
    }
    public componentDidMount() {
        this.attachCanvasRef();

        this.startTransition();
    }

    public componentDidUpdate() {}

    public componentWillUnmount() {
        this.transitionHandler.dispose();
        this.timer && clearTimeout(this.timer);
    }

    public render() {
        return this.renderWithTransition();
    }

    private renderWithTransition = () => {
        const { enterStyle, exitStyle } = this.state;
        const style = this.isPreserve3D() ? {
            transformStyle: 'preserve-3d',
            backfaceVisibility: 'hidden',
        } as any : undefined;

        return (<>
            <div
                className={Styles['transition-preview-enter-wrapper']}
                ref={(element) => {
                    this.enterRef = element;
                }}
                style={{
                    opacity: enterStyle.opacity,
                    zIndex: enterStyle.zIndex,
                    transform: enterStyle.transform,
                    transformOrigin: enterStyle.transformOrigin,
                    ...style,
                }}
            ></div>
            <div
                className={Styles['transition-preview-exit-wrapper']}
                ref={(element) => {
                    this.exitRef = element;
                }}
                style={{
                    opacity: exitStyle.opacity,
                    zIndex: exitStyle.zIndex,
                    transform: exitStyle.transform,
                    transformOrigin: exitStyle.transformOrigin,
                    ...style,
                }}
            ></div>
        </>);
    };

    private updateElementState = (params: IAnimationUpdateParams) => {
        const { target, style } = params;
        const { translateX = 0, translateY = 0, translateZ = 0, rotate = 0, rotateX = 0, rotateY = 0, scale = 1,
            originX = 0.5, originY = 0.5, opacity = 1, zIndex = 0 } = style;

        const { width, height } = this.props.contentSize;
        const transform = `perspective(1500px) rotate(${rotate}deg) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translate(${translateX * width}px, ${translateY * height}px) translateZ(${translateZ}px) scale(${scale})`;
        const transformOrigin = `${originX * 100}% ${originY * 100}%`;
        if (target === TransitionTarget.ENTER) {
            this.setState({
                enterStyle: {
                    opacity,
                    zIndex,
                    transform,
                    transformOrigin,
                },
            });
        } else {
            this.setState({
                exitStyle: {
                    opacity,
                    zIndex,
                    transform,
                    transformOrigin,
                },
            });
        }
    };

    private attachCanvasRef() {
        this.enterRef.appendChild(this.enterCanvas);
    }

    private startTransition = () => {
        this.transitionHandler.startTransition();
    };

    private handleAfterAnimation = (renderInner?: boolean) => {
        if (!renderInner) {
            this.removeExitElement();
        }

        this.props.onTransitionStop?.();
    };

    private handleBeforeAnimation = (renderInner?: boolean) => {
        this.props.onTransitionStart?.();

        if (!renderInner) {
            this.exitRef.appendChild(this.getExitElement());
        }
    };

    private removeExitElement = () => {
        if (this.exitRef.childNodes?.length > 0) {
            this.exitRef.removeChild(this.exitRef.childNodes[0]);
        }
        this.setState({
            enterStyle: {
                opacity: DefaultTransitionStyle.opacity,
                zIndex: DefaultTransitionStyle.zIndex,
                transform: undefined,
                transformOrigin: undefined,
            },
            exitStyle: {
                opacity: DefaultTransitionStyle.opacity,
                zIndex: DefaultTransitionStyle.zIndex,
                transform: undefined,
                transformOrigin: undefined,
            },
        });
    };

    private isPreserve3D = () => this.props.enterSlideModel
        .transition?.getImplementationType() === ImplementationType.PRESERVE_3D;

    private getExitElement() {
        if (this.exitCanvas) {
            return this.exitCanvas;
        }

        return this.createBlackPlaceHolder();
    }

    private createBlackPlaceHolder(): HTMLElement {
        if (!this.blackPlaceHolder) {
            this.blackPlaceHolder = document.createElement('div');
            this.blackPlaceHolder.style.backgroundColor = '#000';
        }

        this.blackPlaceHolder.style.width = '100%';
        this.blackPlaceHolder.style.height = '100%';
        return this.blackPlaceHolder;
    }
}

